module.exports = __webpack_public_path__ + "static/img/dake.02ca61d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dake.png
// module id = Ynqv
// module chunks = 1